import { type PropsWithChildren, useMemo } from 'react';
import { ListLayout, Virtualizer } from 'react-aria-components';

export const DEFAULT_ROW_HEIGHT = 40;

interface VirtualizedListLayoutProps {
  isVirtualized: boolean;
  rowHeight?: number;
}

export function VirtualizedListLayout({
  children,
  isVirtualized,
  rowHeight = DEFAULT_ROW_HEIGHT,
}: PropsWithChildren<VirtualizedListLayoutProps>) {
  const layoutOptions = useMemo(() => ({ estimatedRowHeight: rowHeight }), [rowHeight]);

  if (!isVirtualized) return <>{children}</>;
  return (
    <Virtualizer layout={ListLayout} layoutOptions={layoutOptions}>
      {children}
    </Virtualizer>
  );
}
